import React from 'react';
import SvgIcon from './SvgIcon';

const FloppyDiskFull = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M23.5 22.5a1 1 0 01-1 1h-21a1 1 0 01-1-1V5.414a1 1 0 01.293-.707L4.707.793A1 1 0 015.414.5H22.5a1 1 0 011 1v21z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.5 12.5h15a1 1 0 011 1v10h-17v-10a1 1 0 011-1zM5.5.5h13v6a1 1 0 01-1 1h-11a1 1 0 01-1-1v-6z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.5 2.5h-2v3h2v-3zM6.5 15.5H13M6.5 18.5h11"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

FloppyDiskFull.displayName = 'FloppyDiskFullIcon';

export default FloppyDiskFull;
